import type { LucideIcon } from "lucide-react";

export interface TimelineEntry {
  id: string;
  icon: LucideIcon;
  title: string;
  description?: string;
  source?: string;
  time: string;
  toneClass?: string;
}

interface ActivityTimelineProps {
  entries: TimelineEntry[];
}

export default function ActivityTimeline({ entries }: ActivityTimelineProps) {
  return (
    <div className="flex flex-col">
      {entries.map((e, i) => (
        <div key={e.id} className="relative flex gap-3.5 pb-6 last:pb-0">
          {i < entries.length - 1 && (
            <span className="absolute left-[13px] top-9 bottom-0 w-[2px] bg-line" />
          )}
          <span
            className={`relative z-10 flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${
              e.toneClass ?? "bg-primary-50 text-primary-500"
            }`}
          >
            <e.icon className="h-3.5 w-3.5" />
          </span>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <p className="text-sm font-medium text-ink">{e.title}</p>
              {e.source && (
                <span className="whitespace-nowrap rounded-full bg-page px-2 py-0.5 text-[11px] text-ink-secondary">
                  {e.source}
                </span>
              )}
            </div>
            {e.description && <p className="mt-0.5 text-[13px] text-ink-secondary">{e.description}</p>}
            <p className="mt-0.5 text-xs text-ink-muted">{e.time}</p>
          </div>
        </div>
      ))}
    </div>
  );
}